import ReactMarkdown from 'react-markdown'

export default function Markdown({children, options}){
  return (
    <div  {...options}>
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  )
}